import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { postPAJAI010 } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import SearchDateRange from '../../../shared/components/SearchDateRange';
import SideNav from '../../../shared/components/SideNav';
import { formatDate, formatNumberWithCommas } from '../../../utils';

const PAJAI010 = () => {
    const [data, setData] = useState([]);
    const [pointAnalysis, setPointAnalysis] = useState({});
    const [pages, setPages] = useState({});
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [payload, setPayload] = useState('ALL');

    const handleSearchDateRange = (startDate, endDate) => {
        getListData(startDate, endDate);
    };

    const handleTabClick = (tab) => {
        switch (tab) {
            case 'all':
                setPayload('ALL');
                break;
            case '1':
                setPayload('1');
                break;
            case '2':
                setPayload('2');

                break;
            default:
                setPayload('');
                break;
        }
        setSearchParams({ page: 1 });
    };

    const getListData = (startDate, endDate) => {
        const startDateFormat = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormat = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postPAJAI010({
            page,
            options: { transactionType: [payload] },
            startDate: startDateFormat,
            endDate: endDateFormat,
        })
            .then(({ data }) => {
                setData(data.data.list);
                setPointAnalysis(data.data.pointAnalysis);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        getListData();
        //eslint-disable-next-line
    }, [page, payload]);

    return (
        <div id="content" className="sub-page">
            <div className="container">
                {/* Top Sub Page */}
                <div id="top-sub-page">
                    {/* Side Nav */}
                    <SideNav />
                    <div className="resume">
                        <div className="resume__inner">
                            <h3 className="resume__tit">DV Point 조회</h3>
                            <div className="rsm-mng">
                                <div className="rsm-mng__btbx">
                                    <Link
                                        className="rsm-mng__btn"
                                        onClick={() => {
                                            window.open('https://www.dvmall.co.kr/product-list?cat=A30401&page=1&banner=1&best=0', '_blank');
                                        }}
                                    >
                                        DVmall 바로가기
                                    </Link>
                                </div>
                            </div>
                            <div className="acs-pnt">
                                <div className="acs-pnt__use">
                                    <span>사용가능 포인트</span>
                                    <span className="acs-pnt__num">
                                        <b>{formatNumberWithCommas(pointAnalysis?.availablePoint)}</b> P
                                    </span>
                                </div>
                                <div className="acs-pnt__use">
                                    <span>소멸예정 포인트</span>
                                    <span className="acs-pnt__num red">
                                        <b>{formatNumberWithCommas(pointAnalysis?.totalExtinctPoint)}</b> P
                                    </span>
                                </div>
                            </div>
                            <p className="rsm-stt__srh-desc">
                                * 최근 12개월까지 조회가능합니다. (2024.05.01~2024.08.31)
                            </p>
                            <SearchDateRange
                                className="mt10"
                                handleSearchDateRange={handleSearchDateRange}
                                setSearchParams={setSearchParams}
                            />
                            {/*  table */}
                            <div className="hst">
                                <ul className="hst__tab">
                                    <li className="hst__tab-item">
                                        <Link
                                            className={payload === 'ALL' ? 'active' : ''}
                                            onClick={() => handleTabClick('all')}
                                        >
                                            통합내역
                                        </Link>
                                    </li>
                                    <li className="hst__tab-item">
                                        <Link
                                            className={payload === '1' ? 'active' : ''}
                                            onClick={() => handleTabClick('1')}
                                        >
                                            적립내역
                                        </Link>
                                    </li>
                                    <li className="hst__tab-item">
                                        <Link
                                            className={payload === '2' ? 'active' : ''}
                                            onClick={() => handleTabClick('2')}
                                        >
                                            사용내역
                                        </Link>
                                    </li>
                                </ul>
                                <div className="hst__block">
                                    <table className="hst__table">
                                        <thead>
                                            <tr>
                                                <th>일자</th>
                                                <th>포인트</th>
                                                <th>구분</th>
                                                <th>내역</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data && data.length > 0 ? (
                                                data.map((item, index) => (
                                                    <tr key={'transaction' + index}>
                                                        <td>{formatDate(item.approvalDate, 'YYYYMMDD')}</td>
                                                        <td>
                                                            <span
                                                                className={
                                                                    item.transactionFlag === '1'
                                                                        ? 'hst__plus'
                                                                        : 'hst__minus'
                                                                }
                                                            >
                                                                {item.transactionFlag === '1' ? '+' : '-'}
                                                                {formatNumberWithCommas(item?.pointAmount)} P
                                                            </span>
                                                        </td>
                                                        <td>{item.transactionFlag === '1' ? '적립' : '사용'}</td>
                                                        <td>{item.description}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={4}>데이터없습니다</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <Pagination pages={pages} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PAJAI010;
